export const state = () => ({
  host: process.env.apiUrl,
  titles: {
    news: {
      loaded: false,
      title: '',
      text: '',
      image: '',
    },
    cases: {
      loaded: false,
      title: '',
      text: '',
      image: '',
    },
    world: {
      loaded: false,
      title: '',
      text: '',
      image: '',
    },
    social: {
      loaded: false,
      title: '',
      text: '',
      image: '',
    },
    expert: {
      loaded: false,
      title: '',
      text: '',
      image: '',
    },
    cities: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
    partners: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
    brands: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
    suppliers: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
    brroclab: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
    brnashiprods: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
    brservice: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
    partnersap: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
    partnersmo: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
    vvgoroda: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
    best2cities: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
    gorodusocials: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
    ind: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
    gorodunoname: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
    best2special: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
    best2indoor: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
    sberpromo: {
      loaded: false,
      title: '',
      text: '',
      image: '',
      image_big: '',
    },
  },
  entities: {
    cases: {
      loaded: false,
      items: [],
    },
    world: {
      loaded: false,
      items: [],
    },
    news: {
      loaded: false,
      items: [],
    },
    social: {
      loaded: false,
      items: [],
    },
    expert: {
      loaded: false,
      items: [],
    },
    cities: {
      loaded: false,
      items: [],
    },
    partners: {
      loaded: false,
      items: [],
    },
    brands: {
      loaded: false,
      items: [],
    },
    suppliers: {
      loaded: false,
      items: [],
    },
    // history
    history: {
      loaded: false,
      items: [],
    },
    // products
    products_ind: {
      loaded: false,
      items: [],
    },
    products_outd: {
      loaded: false,
      items: [],
    },
    products_transit: {
      loaded: false,
      items: [],
    },
    products_metro: {
      loaded: false,
      items: [],
    },
    products_metro_spb: {
      loaded: false,
      items: [],
    },
    products_business: {
      loaded: false,
      items: [],
    },
    ind: {
      loaded: false,
      items: [],
    },
    transit: {
      loaded: false,
      items: [],
    },
    metro: {
      loaded: false,
      items: [],
    },
    metro_spb: {
      loaded: false,
      items: [],
    },
    business: {
      loaded: false,
      items: [],
    },
    specbenefits: {
      loaded: false,
      items: [],
    },
    airbenefits: {
      loaded: false,
      items: [],
    },
    products_city: {
      loaded: false,
      items: [],
    },
    brnashiprods: {
      loaded: false,
      items: [],
    },
    brservice: {
      loaded: false,
      items: [],
    },
    outdigital: {
      loaded: false,
      items: [],
    },
    outstatic: {
      loaded: false,
      items: [],
    },
    outservices:{
      loaded: false,
      items: [],
    },
    advretail: {
      loaded: false,
      items: [],
    },
    advtc: {
      loaded: false,
      items: [],
    },
    gorodunoname: {
      loaded: false,
      items: [],
    },
    partnersnn: {
      loaded: false,
      items: [],
    },
    best2special: {
      loaded: false,
      items: [],
    },
    best2airport: {
      loaded: false,
      items: [],
    },
    best2indoor: {
      loaded: false,
      items: [],
    },
    sberpromo: {
      loaded: false,
      items: [],
    },
  },
  single: {
    cases: null,
    news: null,
    world: null,
    product: null,
    social: null,
    cookies: null
  },
  actual: {
    cases: {
      loaded: false,
      items: [],
    },
    world: {
      loaded: false,
      items: [],
    },
    news: {
      loaded: false,
      items: [],
    },
    social: {
      loaded: false,
      items: [],
    },
  },
  infoProds:{
    outdigital: {
      loaded: false,
      image: '',
      detail_image: '',
      slider: []
    },
    outstatic: {
      loaded: false,
      image: '',
      detail_image: '',
      slider: []
    },
    outservices: {
      loaded: false,
      image: '',
      detail_image: '',
      slider: []
    },
    ind: {
      loaded: false,
      image: '',
      detail_image: '',
      slider: []
    },
    outd: {
      loaded: false,
      image: '',
      detail_image: '',
      slider: []
    },
    transit: {
      loaded: false,
      image: '',
      detail_image: '',
      slider: []
    },
    metro: {
      loaded: false,
      image: '',
      detail_image: '',
      slider: []
    },
    metro_spb: {
      loaded: false,
          image: '',
          detail_image: '',
          slider: []
    },
    business: {
      loaded: false,
      image: '',
      detail_image: '',
      slider: []
    },
    advretail: {
      loaded: false,
      image: '',
      detail_image: '',
      slider: []
    },
    advtc: {
      loaded: false,
      image: '',
      detail_image: '',
      slider: []
    },
    spec: {
      title: '',
      loaded: false,
      image: '',
      detail_image: '',
      slider: []
    },
    airp: {
      title: '',
      loaded: false,
      image: '',
      detail_image: '',
      slider: []
    },
  },
  page: 1
});
export const mutations = {

  setTitle(state, titleItem) {
    if (titleItem.value.loaded === undefined) titleItem.value.loaded = true;
    titleItem.value.image = titleItem.value.image ? process.env.base + '/' + titleItem.value.image : null;
    titleItem.value.image_big = titleItem.value.image_big ? process.env.base + '/' + titleItem.value.image_big : null;
    titleItem.value.image_detailed = titleItem.value.image_detailed ? process.env.base + '/' + titleItem.value.image_detailed : null;
    titleItem.value.image_m = titleItem.value.image_m ? process.env.base + '/' + titleItem.value.image_m : null;
    titleItem.value.block_title = titleItem.value.block_title ? titleItem.value.block_title : null;
    state.titles[titleItem.type] = titleItem.value;

  },

  setInfoProds(state, item) {

    if (item.value.loaded === undefined) item.value.loaded = true;
    state.infoProds[item.type] = item.value;
    state.infoProds[item.type].title = item.value.title ? item.value.title : '';
    state.infoProds[item.type].image = item.value.picture ? process.env.base + '/' + item.value.picture : null;
    state.infoProds[item.type].detail_image = item.value.picture ? process.env.base + '/' + item.value.picture : null;
    if(item.value.slider && item.value.slider.length) {
      state.infoProds[item.type].slider = item.value.slider ? item.value.slider.map((slide, key) => {
        return {id: key, image: process.env.base + slide};
      }) : [];
    }
  },

  setEntities(state, { type, value, append }) {

    if (value.loaded === undefined) value.loaded = true;
    const resultArr = [];
    if(value.items) {
      value.items.forEach(item => {
        resultArr.push({
          id: item.id,
          title: item.title,
          block_title: item.block_title || null,
          subtitle: item.subtitle || '',
          showButton: item.url_more ? true : false,
          url_more: item.url_more || '',
          preview_text: item.preview_text || false,
          text: item.text,
          image: process.env.base + item.image,
          link: process.env.base + '' + item.url,
          url:  item.url,
          date: item.date || '',
          video_file: item.video_file || '',
          video_link: item.video_link || '',
          code: item.code || '',
        });
      });
    }
    state.entities[type].loaded = value.loaded;
    if (append) {
      state.entities[type].items = [...state.entities[type].items, ...resultArr];
    } else {
      state.entities[type].items = resultArr;
    }
  },

  setSingle(state, { type, item }) {
    if (!item) {
      state.single[type] = null;
      return false;
    }

    let annotation = item.preview_text ? '<blockquote>'+item.preview_text+'</blockquote>' : '';
	let text;
	let image;

	if (type === 'product')
	{
		if (item.text)
			text = item.text;
		else if (item.detail_text)
			text = item.detail_text;
		else
			text = '';

		if (item.image)
			image = process.env.base + '' + item.image;
		else
			image = '';
	}
	else // news only?
	{
		if (item.text)
			text = annotation + item.text;
		else if (item.detail_text)
			text = annotation + item.detail_text;
		else
			text = annotation;

		image = process.env.base + '' + item.image;
	}

    state.single[type] = {
      id: item.id,
      constr_id: item.constr_id,
      title: item.title,
      preview_text: item.preview_text || '',
      text: text,
      image: image,
      video_file: item.video_file || null,
      video_link: item.video_link || null,
      str_index: item.str_index || null,
      cities_1: item.cities_1 || [],
      // link: state.host + '' + item.url,
      date: item.date || '',
      slides: item.slider ? item.slider.map((slide, key) => {
        return { id: key, image: process.env.base + slide };
      }) : [],
      cities: item.cities_0 ? item.cities_0.map((value, key) => {
        return { id: parseInt(value.id), title: value.name };
      }) : [],
      coords: item.coords || [],
      right_photo: item.right_photo ? process.env.base + item.right_photo : null,
      model_3d: item.model_3d ? process.env.base + item.model_3d : null,
      model_3d_static: item.model_3d_static ? process.env.base + item.model_3d_static : null,
      related: item.linked_prods ? item.linked_prods.map((slide) => {
        slide.image = process.env.base + slide.image;
        return slide;
      }) : [],
      pref_placement: item.pref_placement || '',

      bottom_file: item.bottom_file ? process.env.base + item.bottom_file : null,
      bottom_file_text: item.bottom_file_text ? item.bottom_file_text : null,
      photo_grid: item.photo_grid ? item.photo_grid : [],
    };
  },

  setNewsPage(state, payLoad) {
     state.page = payLoad
  },
  setActual(state, { type, value })  {
   // console.log(value)
    if (value.loaded === undefined) value.loaded = true;
    const resultArr = [];
    if(value) {
      value.forEach(item => {
        resultArr.push({
          id: item.id,
          title: item.title,
          block_title: item.block_title || null,
          subtitle: item.subtitle || '',
          text: item.text,
          image: process.env.base + '/' + item.image,
          link: process.env.base + '' + item.url,
          date: item.date || '',
        });
      });
    }
    state.actual[type].loaded = value.loaded;
    state.actual[type].items = resultArr;
  }
};

export const actions = {

  newsPage({ commit, dispatch, state }, page) {
     return commit('setNewsPage', page);
  },

  async loadTitle({ commit, dispatch, state }, sID) {
    commit('setTitle', {
      type: sID, value: {
        loaded: false, title: '',block_title: '', text: '', image: null,image_detaile:null,image_m:null,
      }
    });

     try {
       const response =  await this.$axios.$get(state.host + '/methods/news/get_title/?sid=' + sID);
       commit('setTitle', { type: sID, value: response });
       return response
     } catch (e) {
         dispatch('showRequestError', e, { root: true });
       throw e
     }



    // return this.$axios.get(state.host + '/methods/news/get_title/?sid=' + sID).then(
    //   (response) => {
    //     commit('setTitle', { type: sID, value: response.data });
    //     return true;
    //   },
    //   (error) => {
    //     dispatch('showRequestError', error, { root: true });
    //     return false;
    //   }
    // );
  },

  async loadInfoProds({ commit, dispatch, state }, sID) {
    // commit('setInfoProds', {
    //   type: sID, value: {
    //     loaded: false, title: '',description: ''
    //   }
    // });

    try {
      const response =  await this.$axios.$get(state.host + '/methods/prods/get_info/?pid=' + sID);
       commit('setInfoProds', { type: sID, value: response });
      return response
    } catch (e) {
       dispatch('showRequestError', e, { root: true });
      throw e
    }

  },

  // { sID, page = 1 }
  async loadEntities({ commit, dispatch, state }, { sID,page = 1,type=''}) {
    const pageNews = state.page;
    const config = {
      headers: {
       // 'Access-Control-Allow-Origin':'*',
        'Content-Type': 'text/html;charset=UTF-8',
      }
    }
    let url;
      // console.log('loadEntities',sID)
     if(type === 'content') {
        url = '/methods/prods/get_list/?pid=' + sID;
     }else{
        url = '/methods/news/get_list/?sid=' + sID + '&PAGEN_1=' + pageNews;
       if (sID === 'products') {
         if (['outd', 'ind', 'spec', 'city', 'transit', 'metro', 'business', 'metro_spb'].indexOf(page) !== -1) {
           url = '/methods/prods/get_list_x/?pid=' + page;
           sID = 'products_' + page;
         } else {
           return false;
         }
       }
     }


    // console.log('url',url)

    return this.$axios.get(state.host + url,config).then(
      (response) => {
        if(sID === 'news') {

          commit('setEntities', { type: sID, value: { items: response.data }, append: pageNews > 1 });
        }else{

          commit('setEntities', { type: sID, value: { items: response.data }, append: page > 1 });
        }

        return true;
      },
      (error) => {
        dispatch('showRequestError', error, { root: true });
        return false;
      }
    );
  },

  async loadSingle({ commit, dispatch, state }, { sID, ID }) {
   // console.log('load API version of single sId = ' + sID + ', id = ' + ID);
    // reset

    commit('setSingle', { type: sID, item: null });

    // products or other single items?
    let url = '/methods/news/get_item/?id=' + ID;
    if (sID === 'product') {
      url = '/methods/prods/get_item/?id=' + ID;
    }

    return this.$axios.get(state.host + url).then(
      (response) => {
        console.log('... loaded');
        commit('setSingle', { type: sID, item: response.data });
        return response;
      },
      (error) => {
        console.log('... error');
        if (sID === 'news') {
          this.$router.push('/news');
        }
        dispatch('showRequestError', error, { root: true });
        return false;
      }
    );
  },

  async loadActual({commit, dispatch, state},{sID,ID}) {
    try {
      const response =  await this.$axios.$get(state.host + '/methods/news/get_actual/?sid=' + sID + '&id=' + ID);
      commit('setActual', { type: sID, value: response });
      return response
    } catch (e) {
      dispatch('showRequestError', e, { root: true });
      throw e
    }
  },
  sendFeedbackSber({ commit, dispatch, state }, { name, phone, email }) {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await this.$axios.get(state.host + '/methods/feedback/send/sber.php?name=' + name + '&phone=' + phone + '&email=' + email);
        resolve(result);
      } catch (e) {
        reject(e);
      }
    });
  },
  sendFeedbackIllegal({ commit, dispatch, state }, { formData }) {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await this.$axios.post(state.host + '/methods/feedback/send/illegal.php', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        resolve(result);
      } catch (e) {
        reject(e);
      }
    });
  },
  sendFeedback({ commit, dispatch, state }, { name, phone, token }) {
    //console.log('send API version of feedback, name: ' + name + ', phone: ' + phone);
    return new Promise(async (resolve, reject) => {
      try {
        const result = await this.$axios.get(state.host + '/methods/feedback/send/?name=' + name + '&phone=' + phone + '&token=' + token);
        resolve(result);
      } catch (e) {
        reject(e);
      }
    });
  },

  sendOffers({ commit, dispatch, state }, { fio, phone, company, email, text }) {
    //console.log('send API version of sendOffers, name: ' + fio + ', phone: ' + phone+ ', company: ' + company+ ', email: ' + email+ ', text: ' + text);
    return new Promise(async (resolve, reject) => {
      try {
        const ms = {
          data: { 'success':true}
        }
        //
        resolve(ms);
      } catch (e) {
        reject(e);
      }
    });
  },

};



// WEBPACK FOOTER //
// ./store/content.js